!(function (a, b) {
  var c = b();
  (a.t8 = c), 'undefined' != typeof exports && (module.exports = c);
})(this, function () {
  'use strict';
  var a = {},
    b = (function () {
      function a(a, b, c) {
        if (null === a || void 0 === a) return -1;
        var d = Array.prototype.indexOf;
        if (d && a.indexOf === d) return a.indexOf(b, c);
        for (var e = 0, f = a.length; f > e; e++) if (a[e] === b) return e;
        return -1;
      }
      function b(a) {
        return 'undefined' != typeof a && null !== a;
      }
      function c(a) {
        return '[object Array]' === Object.prototype.toString.call(a);
      }
      function d(a) {
        return '[object String]' === Object.prototype.toString.call(a);
      }
      function e(a, b) {
        if (!a) throw new Error(b);
      }
      function f(a, b) {
        var c = a;
        if (!(a instanceof Date))
          if (isNaN(a)) {
            if ('string' != typeof a)
              throw new Error(
                "Invalid date parameter '" +
                  a +
                  "'. Expected number or string timestamp or ISO date string"
              );
            c = g(a);
          } else c = new Date(parseInt(a + '', 10));
        if (!c) throw new Error("t8 could not parse date string '" + a + "'");
        return b && (c = h(c)), c;
      }
      function g(a) {
        var b,
          c,
          d,
          e = a.match(j),
          f = e && '-' === e[11];
        if (!e) return null;
        for (b = 0, c = e.length; c > b; b++) e[b] = ~~e[b];
        return (
          (d = 6e4 * (60 * e[12] + e[13]) * (f ? 1 : -1)),
          new Date(Date.UTC(e[1], e[2] - 1, e[3], e[6], e[7], e[8], e[9]) + d)
        );
      }
      function h(a) {
        var b = new Date(a.getTime());
        return b.setMinutes(a.getMinutes() - a.getTimezoneOffset()), b;
      }
      function i(a, b, c) {
        try {
          return a.apply(b, c);
        } catch (d) {
          return (l.value = d), l;
        }
      }
      var j =
          /^(\d{4})-(\d{2})-(\d{2})((T(\d{2}):(\d{2}):(\d{2}))?(?:\.(\d+))?(Z|([+-])(\d{2})(?::(\d{2}))?))?$/,
        k = /\u200e/g,
        l = { value: null };
      return {
        parseDateString: f,
        assert: e,
        isString: d,
        isArray: c,
        isDefined: b,
        indexOf: a,
        tryCatch: i,
        errorObject: l,
        RTL_PATTERN: k,
      };
    })();
  'undefined' != typeof module &&
    'undefined' != typeof module.exports &&
    (module.exports = b);
  var c = (function () {
      var b = function () {};
      return (
        (b.prototype.format = function (b, c, d) {
          var e,
            f = '',
            g = a[d],
            h = {
              style: 'currency',
              currency: c,
              currencyDisplay: 'code',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            };
          if (!g) throw new Error('No locale data found for locale ' + d);
          if (!g.intlLocale)
            throw new Error('IntlLocale is not specified for locale ' + d);
          g.currency &&
            'function' == typeof g.currency.getCurrencyDisplay &&
            (h.currencyDisplay = g.currency.getCurrencyDisplay(c)),
            ('INR' === c || 'JPY' === c) &&
              ((h.minimumFractionDigits = 0), (h.maximumFractionDigits = 0));
          try {
            (e = new Intl.NumberFormat(
              g.intlLocale + '-u-nu-latn-ca-gregory',
              h
            )),
              (f = e.format(b));
          } catch (i) {
            if ('code' === h.currencyDisplay)
              try {
                (h.currencyDisplay = 'symbol'),
                  (e = new Intl.NumberFormat(
                    g.intlLocale + '-u-nu-latn-ca-gregory',
                    h
                  )),
                  (f = e.format(b));
                var j = [
                    '(AU|A|US|BR|R|CAN|CA|C|A|HK|NZ|SG)\\u0024',
                    '\\u0024(AU|A|US|BR|R|CAN|CA|C|A|HK|NZ|SG)|\\u0024',
                    'GB£|£GB|£',
                    '€',
                    'ر.ه.‏',
                    'JP¥|¥JP|¥',
                    '₹|Rs',
                    'Dkr',
                    'NKr',
                    'kr',
                  ],
                  k = new RegExp('(' + j.join('|') + ')');
                f = f.replace(k, c);
              } catch (l) {
                f = b + ' ' + c;
              }
          }
          return (
            (f = f.replace(/\u0020/g, ' ')),
            g.currency &&
              g.currency.postFormatting &&
              (f = g.currency.postFormatting(c, b, f)),
            f
          );
        }),
        b
      );
    })(),
    d = (function () {
      function c(a) {
        return 10 > a ? '0' + a : a;
      }
      function d(a) {
        return (
          a.getUTCFullYear() +
          '-' +
          c(a.getUTCMonth() + 1) +
          '-' +
          c(a.getUTCDate())
        );
      }
      var e = b.RTL_PATTERN,
        f = function () {
          this.instanceCache = {};
        };
      return (
        (f.prototype.format = function (c, f, g, h) {
          var i,
            j,
            k,
            l,
            m,
            n = '',
            o = a[f],
            p = b.parseDateString(c, h),
            q = b.tryCatch,
            r = this.instanceCache;
          if ('d.narrow' === g && o.date.narrowDayNames)
            return o.date.narrowDayNames[p.getDay()];
          if ('iso' === g) return d(p);
          if (!o) throw new Error('No locale data found for locale ' + f);
          if (!o.intlLocale)
            throw new Error('IntlLocale is not specified for locale ' + f);
          return (
            (j = o.date.intlOptions[g]),
            (j.timeZone = 'UTC'),
            (m = q(function () {
              (k = o.intlLocale),
                'zh' !== k && (k += '-u-nu-latn-ca-gregory'),
                (l = k + g),
                (i = r[l]),
                i || (i = r[l] = new Intl.DateTimeFormat(k, j)),
                (n = i.format(p));
            }, void 0)),
            m === b.errorObject && (n = p.toLocaleDateString()),
            (n = n.replace(e, '')),
            o.date &&
              o.date.postFormatting &&
              (n = o.date.postFormatting(g, c, n)),
            n
          );
        }),
        f
      );
    })(),
    e = (function () {
      function a(a) {
        if (!a) return !1;
        var b = j.charsets.korean,
          c = a.charCodeAt(0);
        return c >= b.lowerbound && c <= b.upperbound;
      }
      function c(a) {
        if (!a) return !1;
        for (
          var b = a.charCodeAt(0), c = j.charsets.CJ, d = 0, e = c.length;
          e > d;
          d++
        )
          if (b >= c[d].lowerbound && b >= c[d].upperbound) return !0;
        return !1;
      }
      function d(a, c) {
        for (
          var d = a.defaultTemplate, e = a.localeTemplates, f = 0, g = e.length;
          g > f;
          f++
        )
          b.indexOf(e[f].locales, c) >= 0 && (d = e[f].template);
        return d;
      }
      function f(a) {
        var c = e.formats,
          d = e.templates;
        return a
          ? (b.isString(a) && (a = [a]),
            b.isArray(a)
              ? b.indexOf(a, c.FULL_NAME) >= 0
                ? d.FULL_NAME
                : b.indexOf(a, c.LIST_VIEW) >= 0
                ? d.LIST_VIEW
                : d.FAMILIAR_NAME
              : d.FAMILIAR_NAME)
          : d.FAMILIAR_NAME;
      }
      function g(a) {
        if (a) {
          if (b.isArray(a)) return b.indexOf(a, e.formats.MICROFORMAT) >= 0;
          if (b.isString(a)) return a === e.formats.MICROFORMAT;
        }
        return !1;
      }
      function h(a, b, c, d, e) {
        if (!a) return '';
        var f = a.replace(i, '');
        return b && (f = d(f)), c && (f = e(f)), f;
      }
      var i = /(^\s+|\s+$)/g,
        j = function () {};
      return (
        (j.formats = {
          FAMILIAR_NAME: 'FAMILIAR_NAME',
          FULL_NAME: 'FULL_NAME',
          MICROFORMAT: 'MICROFORMAT',
          LIST_VIEW: 'LIST_VIEW',
        }),
        (j.templates = {
          MICROFORMAT: {
            firstName: function (a) {
              return '<span class="given-name">' + a + '</span>';
            },
            lastName: function (a) {
              return '<span class="family-name">' + a + '</span>';
            },
            maidenName: function (a) {
              return '<span class="additional-name">' + a + '</span>';
            },
          },
          FAMILIAR_NAME: {
            defaultTemplate: function (a, b, c) {
              return a;
            },
            localeTemplates: [
              {
                locales: ['de_DE', 'pl_PL', 'ro_RO', 'tr_TR'],
                template: function (a, b, c) {
                  return a + ' ' + b;
                },
              },
              {
                locales: ['CJK'],
                template: function (a, b, c) {
                  return b + a;
                },
              },
              {
                locales: ['CJK-ja_JP'],
                template: function (a, b, c) {
                  return b + ' ' + a;
                },
              },
            ],
          },
          FULL_NAME: {
            defaultTemplate: function (a, b, c) {
              return a + (c ? ' (' + c + ')' : '') + ' ' + b;
            },
            localeTemplates: [
              {
                locales: ['ar_AE', 'th_TH'],
                template: function (a, b, c) {
                  return a + (c ? ' ' + c : '') + (b ? ' ' + b : '');
                },
              },
              {
                locales: ['cs_CZ'],
                template: function (a, b, c) {
                  return (
                    a + (b ? ' ' + b : '') + (c ? ' (roz. ' + c + ')' : '')
                  );
                },
              },
              {
                locales: ['de_DE'],
                template: function (a, b, c) {
                  return a + (b ? ' ' + b : '') + (c ? ' geb. ' + c : '');
                },
              },
              {
                locales: ['CJK-ja_JP'],
                template: function (a, b, c) {
                  return b + (a ? ' ' + a : '') + (c ? ' (' + c + ')' : '');
                },
              },
              {
                locales: ['CJK'],
                template: function (a, b, c) {
                  return b + a + (c ? ' (' + c + ')' : '');
                },
              },
              {
                locales: ['ms_MY'],
                template: function (a, b, c) {
                  return a + (b ? ' ' + b : '') + (c ? ' (' + c + ')' : '');
                },
              },
              {
                locales: ['nl_NL'],
                template: function (a, b, c) {
                  return a + ' ' + b + (c ? '-' + c : '');
                },
              },
              {
                locales: ['pl_PL'],
                template: function (a, b, c) {
                  return a + (b ? ' ' + b : '') + (c ? ' z d. ' + c : '');
                },
              },
            ],
          },
          LIST_VIEW: {
            defaultTemplate: function (a, b, c) {
              return (b ? b + ', ' : '') + a;
            },
            localeTemplates: [
              {
                locales: ['CJK'],
                template: function (a, b, c) {
                  return b + a;
                },
              },
              {
                locales: ['CJK-ja_JP'],
                template: function (a, b, c) {
                  return b + ' ' + a;
                },
              },
              {
                locales: ['ar_AE', 'in_ID', 'ms_MY', 'th_TH'],
                template: function (a, b, c) {
                  return a + ' ' + b;
                },
              },
            ],
          },
        }),
        (j.locales = { CJK: 'CJK', CJK_ja_JP: 'CJK-ja_JP', ja_JP: 'ja_JP' }),
        (j.charsets = {
          korean: { lowerbound: 44032, upperbound: 55215 },
          CJ: [
            { lowerbound: 19968, upperbound: 40895 },
            { lowerbound: 12448, upperbound: 12543 },
            { lowerbound: 65377, upperbound: 65439 },
            { lowerbound: 12352, upperbound: 12447 },
          ],
        }),
        (j.prototype.htmlEncode = function (a) {
          return null === a || void 0 === a
            ? null
            : a.toString().replace(/(.)/g, function (a) {
                return '<' === a
                  ? '&lt;'
                  : '>' === a
                  ? '&gt;'
                  : '&' === a
                  ? '&amp;'
                  : '"' === a
                  ? '&quot;'
                  : "'" === a
                  ? '&#39;'
                  : '\\' === a
                  ? '&#92;'
                  : '=' === a
                  ? '&#61;'
                  : '\x00' === a
                  ? '�;'
                  : a;
              });
        }),
        (j.prototype.format = function (b, j, k) {
          var l = g(j),
            m = l || b.lastNameWithHighlight,
            n = e.templates.MICROFORMAT,
            o = h(b.firstName, m, l, this.htmlEncode, n.firstName),
            p = h(b.lastName, m, l, this.htmlEncode, n.lastName),
            q = h(b.maidenName, m, l, this.htmlEncode, n.maidenName),
            r = h(b.lastNameWithHighlight, !1, l, this.htmlEncode, n.lastName),
            s = '',
            t = '';
          return (
            a(b.lastName)
              ? (k = e.locales.CJK)
              : c(b.lastName) &&
                (k =
                  k === e.locales.ja_JP ? e.locales.CJK_ja_JP : e.locales.CJK),
            (s = d(f(j), k)),
            (t = s(o, r ? r : p, q)),
            (t = t.replace(i, ''))
          );
        }),
        j
      );
    })(),
    f = (function () {
      function b(a, b) {
        try {
          return a.format(b);
        } catch (c) {
          return b + '';
        }
      }
      function c(a, b, c) {
        var d = a[b];
        return d || (d = a[b] = new Intl.NumberFormat(b, c)), d;
      }
      var d = function () {
        this.instanceCache = {};
      };
      return (
        (d.prototype.format = function (d, e) {
          var f,
            g = '',
            h = a[e],
            i = { maximumFractionDigits: 3 };
          if (!h) throw new Error('No locale data found for locale ' + e);
          if (!h.intlLocale)
            throw new Error('IntlLocale is not specified for locale ' + e);
          return (
            h.number &&
              h.number.maximumFractionDigits &&
              (i.maximumFractionDigits = h.number.maximumFractionDigits),
            (f = c(
              this.instanceCache,
              h.intlLocale + '-u-nu-latn-ca-gregory',
              i
            )),
            (g = b(f, d)),
            h.number &&
              h.number.postFormatting &&
              (g = h.number.postFormatting(d, g)),
            g
          );
        }),
        d
      );
    })(),
    g = (function () {
      var c = function () {};
      return (
        (c.prototype.format = function (c, d) {
          var e,
            f = a[d],
            g = f.possessive ? f.possessive : {};
          if (b.isDefined(g)) {
            e = g.fallback;
            for (var h in g.rules)
              if (new RegExp(h).test(c)) {
                e = g.rules[h];
                break;
              }
          }
          return b.isDefined(e) ? c + e : c;
        }),
        c
      );
    })(),
    h = (function () {
      var c = b.RTL_PATTERN,
        d = function () {
          this.instanceCache = {};
        };
      return (
        (d.prototype.format = function (d, e, f, g) {
          var h,
            i,
            j,
            k,
            l,
            m = '',
            n = a[e],
            o = b.parseDateString(d, g),
            p = {
              hm: { hour: 'numeric', minute: 'numeric' },
              hms: { hour: 'numeric', minute: 'numeric', second: 'numeric' },
            },
            q = b.tryCatch,
            r = this.instanceCache;
          if (!n) throw new Error('No locale data found for locale ' + e);
          if (!n.intlLocale)
            throw new Error('IntlLocale is not specified for locale ' + e);
          return (
            (i = n.time && n.time.intlOptions ? n.time.intlOptions[f] : p[f]),
            i || (i = p.hms),
            (i.timeZone = 'UTC'),
            (l = q(function () {
              (j = n.intlLocale),
                'zh' !== j && (j += '-u-nu-latn-ca-gregory'),
                (k = j + f),
                (h = r[k]),
                h || (h = r[k] = new Intl.DateTimeFormat(j, i)),
                (m = h.format(o));
            }, void 0)),
            l === b.errorObject && (m = o.toLocaleTimeString()),
            (m = m.replace(c, '')),
            n.time &&
              n.time.postFormatting &&
              (m = n.time.postFormatting(f, d, m)),
            m
          );
        }),
        d
      );
    })(),
    i = (function () {
      var a = '...',
        b = function (b) {
          a = 'undefined' != typeof b ? b : a;
        };
      return (
        (b.prototype.format = function (b, c) {
          if (!b || 'string' != typeof b)
            return 'undefined' == typeof b || '' === b ? '' : null;
          if ('undefined' == typeof c) return '...';
          if (
            !c ||
            'number' != typeof c ||
            c >= b.length ||
            0 > c ||
            0 === b.replace(/\s/g, '').length
          )
            return b;
          for (
            var d = b.substr(0, c),
              e = d.split(''),
              f = c - 1,
              g = '',
              h = /\s|\?|\!|\.|\,|\;|\:/g;
            f >= 0 && !h.test(e[f]);

          )
            f--;
          return (g = f > 0 ? d.substr(0, f) : d), (g += a);
        }),
        b
      );
    })(),
    j = (function () {
      function c(a) {
        return 'number' == typeof a && a === a ? a : d(a);
      }
      function d(a) {
        try {
          if ('undefined' != typeof a) {
            if (!isNaN(a)) return parseInt(a + '', 10);
            var b = a.replace(/[^0-9]/g, ''),
              c = parseInt(b, 10);
            return isNaN(c) ? 0 : c;
          }
        } catch (d) {}
        return 0;
      }
      function e(a, b) {
        return -1 !== a.indexOf(b, a.length - b.length);
      }
      var f,
        g = function () {},
        h = b.isDefined,
        i = 2;
      return (
        (g.CATEGORIES = {
          SINGULAR: 0,
          PLURAL: 1,
          DUAL: 2,
          FEW: 3,
          MANY: 4,
          ZERO: 5,
        }),
        (f = {
          equals: { 1: g.CATEGORIES.SINGULAR },
          endsWith: {
            0: g.CATEGORIES.PLURAL,
            1: g.CATEGORIES.PLURAL,
            2: g.CATEGORIES.PLURAL,
            3: g.CATEGORIES.PLURAL,
            4: g.CATEGORIES.PLURAL,
            5: g.CATEGORIES.PLURAL,
            6: g.CATEGORIES.PLURAL,
            7: g.CATEGORIES.PLURAL,
            8: g.CATEGORIES.PLURAL,
            9: g.CATEGORIES.PLURAL,
          },
        }),
        (g.COMPARISONS = {
          eq: function (a, b) {
            return a === b;
          },
          gt: function (a, b) {
            return a > b;
          },
          gte: function (a, b) {
            return a >= b;
          },
          endsWith: function (a, b) {
            return e(a.toString(), b.toString());
          },
        }),
        (g.prototype.findRule = function (a, b, c) {
          var d;
          if (!h(a)) return d;
          for (var e = 0, f = a.length; f > e; e++) {
            d = a[e];
            for (var g = 0, i = d.values.length; i > g; g++)
              if (c(b, d.values[g])) return d;
          }
          return void 0;
        }),
        (g.prototype.pickCategory = function (a, b, c) {
          if (h(a) && h(b) && h(c)) {
            var d = b.toString();
            if (h(a.equals) && h(a.equals[d])) return a.equals[d];
            if (h(a.endsWith))
              for (var e = Math.min(c, d.length), f = e; f > 0; f--) {
                var g = d.slice(-1 * f);
                if (h(a.endsWith[g])) return a.endsWith[g];
              }
          }
          return void 0;
        }),
        (g.prototype.findCategoryMatch = function (a, b, c) {
          a = Math.floor(a);
          var d = this.findNumberMatchNoRanges(a, b);
          if (h(d)) return d;
          var e,
            f,
            j = this.pickCategory(c, a, i);
          if (h(j)) {
            for (var k in g.CATEGORIES)
              g.CATEGORIES[k] === j && (e = k.toLowerCase());
            for (var l = 0, m = b.length; m > l; l++) {
              if (b[l].category === e) return b[l];
              'plural' === b[l].category && (f = b[l]);
            }
            if (f) return f;
          }
          return void 0;
        }),
        (g.prototype.findNumberMatchNoRanges = function (a, b) {
          for (var c, d, e = [], f = 0, g = b.length; g > f; f++)
            if (((c = b[f]), (d = {}), h(c.arg) && 'gte' === c.comparison)) {
              for (var i in c) d[i] = c[i];
              (d.comparison = 'eq'), e.push(d);
            } else e.push(c);
          return this.findNumberMatch(a, e);
        }),
        (g.prototype.findNumberMatch = function (a, b) {
          for (var c, d = 0; d < b.length; d++) {
            var e = b[d],
              f = j.COMPARISONS[e.comparison];
            f(a, e.arg) && (!h(c) || e.arg > c.arg) && (c = e);
          }
          return c;
        }),
        (g.prototype.isValidCategory = function (a) {
          return 'undefined' != typeof g.CATEGORIES[a.toUpperCase()];
        }),
        (g.prototype.format = function (b, d, e) {
          for (
            var g,
              i,
              j = a[e],
              k = j.chooser ? j.chooser : f,
              l = c(b),
              m = !1,
              n = 0,
              o = d.length;
            o > n;
            n++
          )
            if (h(d[n].category)) {
              m = !0;
              break;
            }
          return (
            (g = m
              ? this.findCategoryMatch(l, d, k)
              : this.findNumberMatch(l, d)),
            g && ((i = g.text), 'function' == typeof i) ? i() : i
          );
        }),
        g
      );
    })(),
    k = (function () {
      var a = function (a, b) {
          (this.i18nCacheStatic = a), (this.i18nCacheDynamic = b);
        },
        c = '__i18n__';
      return (
        (a.prototype.get = function (a, c, d, e) {
          b.assert(e, 'get called with null callback'),
            b.assert(a, 'get called with null or empty key'),
            b.assert(c, 'get called with null or empty namespace');
          var f = this.getStaticString(a, c);
          b.isDefined(f) ? e(null, f) : this.renderDynamicString(a, c, d, e);
        }),
        (a.prototype.getStaticString = function (a, c) {
          return (
            b.assert(a, 'getStaticString called with null or empty key'),
            b.assert(c, 'getStaticString called with null or empty namespace'),
            this.i18nCacheStatic &&
            this.i18nCacheStatic.cache &&
            this.i18nCacheStatic.cache[c]
              ? this.i18nCacheStatic.cache[c][a]
              : void 0
          );
        }),
        (a.prototype.renderDynamicString = function (a, c, d, e) {
          b.assert(e, 'renderDynamicString called with null callback'),
            b.assert(a, 'renderDynamicString called with null or empty key'),
            b.assert(
              c,
              'renderDynamicString called with null or empty namespace'
            );
          var f = this.dynamicKeyName(a, c);
          this.i18nCacheDynamic &&
          this.i18nCacheDynamic.cache &&
          this.i18nCacheDynamic.cache[f]
            ? t8.renderDynamicString(f, this.i18nCacheDynamic.cache[f], d, e)
            : e(
                'Could not find static i18n key ' +
                  a +
                  ' in static i18n cache nor dynamic i18n template ' +
                  f +
                  ' in dynamic i18n cache.'
              );
        }),
        (a.prototype.dynamicKeyName = function (a, d) {
          return (
            b.assert(a, 'dynamicKeyName called with null or empty key'),
            b.assert(d, 'dynamicKeyName called with null or empty namespace'),
            c + d + '__' + a
          );
        }),
        a
      );
    })(),
    l = (function () {
      function a(a) {
        if (!b.isDefined(a)) return -1;
        var c = 0,
          d = '\x00',
          e = a.length;
        for (c = 0; e > c && ((d = a.charAt(c)), !(f.indexOf(d) < 0)); c++);
        return c >= e ? -1 : d >= g && h >= d ? c : -1;
      }
      var c = function () {},
        d = ' \n\r	\f \u2028\u2029'.split(''),
        e = '~!@#$%^&*()_+`1234567890-={}|[]\\:";\'<>?,./'.split(''),
        f = d.concat(e),
        g = '֐',
        h = 'ۿ',
        i = (function (a) {
          var b = { nbsp: ' ', lt: '<', gt: '>', amp: '&', quot: '"' },
            c = /&(?:(lt|gt|amp|quot|nbsp)|#x([\da-f]{1,4})|#(\d{1,5}));/gi;
          return function (d) {
            return null === d || d === a
              ? null
              : (d + '').replace(c, function (a, c, d, e) {
                  return c
                    ? b[c]
                    : d || e
                    ? String.fromCharCode(
                        parseInt(d || e, d ? 16 : 10) || 65533
                      )
                    : '�';
                });
          };
        })();
      return (
        (c.prototype.isRtl = function (b) {
          return -1 !== a(i(b));
        }),
        c
      );
    })();
  return {
    Chooser: j,
    CurrencyFormatter: c,
    DateFormatter: d,
    NameFormatter: e,
    NumberFormatter: f,
    Possessive: g,
    Resources: k,
    Rtl: l,
    TimeFormatter: h,
    TruncationFormatter: i,
    __addLocaleData: function (b, c) {
      a[b] = c;
    },
  };
});
